import _ from 'underscore';
import { replaceCurly } from '@bingads-webui-campaign/fluctuation-common';

export const generateDescription = ({ description, deps }) => {
  const { context, i18n } = deps;
  const tempMessage = i18n.getString(description.MessageId);
  if (tempMessage.indexOf('{0}') > -1) {
    return replaceCurly(
      i18n.getString(description.MessageId),
      context,
      description.Parameters[0].Values[0]
    );
  }
  return tempMessage;
};

// Flatten [{ Date, FluctuationsPerDate[] }...] to [{ Date, Fluctuation }...]
export const flattenFluctuationsDict = (dateFluxMap) => {
  let flattenedDateFlux = [];

  const descSortedDateFluxMap = _.sortBy(
    dateFluxMap,
    unsortedDateFluxMap =>
      unsortedDateFluxMap.Date && (new Date(unsortedDateFluxMap.Date)).getTime()
  ).reverse();

  descSortedDateFluxMap.forEach((dateFluxPair) => {
    const { Date, FluctuationsPerDate = [] } = dateFluxPair || {};
    FluctuationsPerDate.forEach((Fluctuation) => {
      flattenedDateFlux = [
        ...flattenedDateFlux,
        {
          Date,
          Fluctuation,
        },
      ];
    });
  });

  return flattenedDateFlux;
};

export const getFluctuationMetricUtil = (flucType) => {
  switch (flucType) {
    case 1:
      // Impressions
      return 5;
    case 2:
      // Clicks
      return 1;
    case 3:
      // Spent
      return 6;
    case 4:
      // Conv
      return 3;
    default:
      return null;
  }
};
